// Mock data for MS Building Contractors website

export const contactInfo = {
  directors: [
    {
      name: "Martyn",
      phone: "07398238042",
      role: "Director"
    },
    {
      name: "Jake",
      phone: "07512760062",
      role: "Director"
    }
  ],
  email: "msbuildingandjoinery16@gmail.com",
  companyName: "MS Building Contractors",
  socialMedia: {
    instagram: "https://www.instagram.com/msbuildingcontractors16?igsh=YzZmZjdvd2FldXBk",
    facebook: "https://www.facebook.com/share/1CboF8gs75/?mibextid=wwXIfr"
  }
};

export const services = [
  {
    id: 1,
    title: "Extensions",
    description: "Transform your home with expertly crafted extensions that seamlessly blend with your existing structure. We handle everything from planning to completion.",
    features: ["Single & Double Storey", "Side & Rear Extensions", "Planning Support", "Full Project Management"]
  },
  {
    id: 2,
    title: "Kitchens",
    description: "Create your dream kitchen with our comprehensive kitchen installation service. From design to the finishing touches, we deliver excellence.",
    features: ["Custom Design", "Quality Fitting", "Modern Appliances", "Complete Installation"]
  },
  {
    id: 3,
    title: "Patios",
    description: "Beautiful outdoor living spaces with professional patio installation. From paving to decking, we create stunning outdoor areas for you to enjoy.",
    features: ["Paving & Slabbing", "Decking Installation", "Landscaping", "Drainage Solutions"]
  },
  {
    id: 4,
    title: "First & Second Fix Joinery",
    description: "Professional joinery services including doors, skirting, architrave, stairs, and bespoke carpentry work to the highest standards.",
    features: ["Door Hanging", "Skirting & Architrave", "Staircases", "Bespoke Carpentry"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Luxury Kitchen Extension with Skylight",
    category: "Kitchen",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/oj35v41k_2e4e8745-008c-4125-ad07-32fd52072e34.jpeg",
    description: "Stunning open-plan kitchen extension featuring vaulted ceiling with skylights and herringbone flooring"
  },
  {
    id: 2,
    title: "Contemporary Kitchen Installation",
    category: "Kitchen",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/0i6q6h27_IMG_7163.heic",
    description: "Modern white shaker kitchen with farmhouse sink and natural wood island"
  },
  {
    id: 3,
    title: "Elegant Kitchen Renovation",
    category: "Kitchen",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/on5tqsn3_IMG_7161.heic",
    description: "Sophisticated kitchen featuring herringbone flooring and integrated appliances"
  },
  {
    id: 4,
    title: "High-End Kitchen with Miele Appliances",
    category: "Kitchen",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/xx70isyh_IMG_0229.heic",
    description: "Premium kitchen renovation with marble island and brass pendant lighting"
  },
  {
    id: 5,
    title: "Modern Farmhouse Kitchen",
    category: "Kitchen",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/5b9v4yi5_IMG_0230.heic",
    description: "Beautiful white shaker kitchen with quartz island and herringbone flooring"
  },
  {
    id: 6,
    title: "White Shaker Kitchen Installation",
    category: "Kitchen",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/emyjhviy_IMG_0584.heic",
    description: "Clean white shaker kitchen with industrial pendant lights and integrated ovens"
  },
  {
    id: 7,
    title: "Classic White Kitchen Build",
    category: "Kitchen",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/t958zao6_IMG_0586.heic",
    description: "Traditional white kitchen installation with modern fixtures and brass hardware"
  },
  {
    id: 8,
    title: "Contemporary Grey Kitchen with Island",
    category: "Kitchen",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/tgh2sxbt_388a920c-6df4-4097-90aa-ee50ce90729f.jpeg",
    description: "Stylish grey kitchen with large island, bar seating and American fridge"
  },
  {
    id: 9,
    title: "Modern Grey Shaker Kitchen",
    category: "Kitchen",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/78um4znj_48b3846b-9200-4d8f-b1b6-6280d70952ed.jpeg",
    description: "Elegant grey shaker kitchen with white quartz worktops"
  },
  {
    id: 10,
    title: "Designer Kitchen Installation",
    category: "Kitchen",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/okbtr1ov_9b3eaf15-724b-4bc3-9ef3-c9e5e663e300.jpeg",
    description: "Premium kitchen fit with contemporary cabinetry and professional lighting"
  },
  {
    id: 11,
    title: "Modern House Extension with Bi-Fold Doors",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/krvuffum_IMG_7133.heic",
    description: "Contemporary ground-floor extension with large bi-fold glass doors and patio"
  },
  {
    id: 12,
    title: "Brick Extension with Glazed Windows",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/pniw150i_IMG_7142.heic",
    description: "Modern extension featuring matching brickwork and extensive glazing"
  },
  {
    id: 13,
    title: "Extension with Garage and Utility Room",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/u83umlb1_d4a5c3a2-f66a-457e-948e-524f3fe0dd49.jpeg",
    description: "Multi-functional brick extension with covered parking and additional room"
  },
  {
    id: 14,
    title: "House Extension with New Patio Area",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/qslxas5d_IMG_0218.heic",
    description: "Ground-floor extension with landscaped garden and paved patio"
  },
  {
    id: 15,
    title: "Conservatory Extension with Patio",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/yfm0umak_IMG_0213.heic",
    description: "Bright conservatory addition with large windows and tiled patio area"
  },
  {
    id: 16,
    title: "Patio Ground Preparation",
    category: "Patio",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/xpodtg3x_IMG_3962.heic",
    description: "Professional groundworks preparation for new patio installation"
  },
  {
    id: 17,
    title: "Completed Extension with Garden",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/nioh66nq_IMG_3963.heic",
    description: "Brick extension with paved patio and landscaped garden"
  },
  {
    id: 18,
    title: "Patio Foundation Works",
    category: "Patio",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/kdkt985m_IMG_4008.heic",
    description: "Sub-base preparation and leveling for patio installation"
  },
  {
    id: 19,
    title: "Modern Grey Stone Patio",
    category: "Patio",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/ogcuf72c_IMG_4382.heic",
    description: "Large format grey stone tiles with gravel edging"
  },
  {
    id: 20,
    title: "Contemporary Patio and Extension",
    category: "Patio",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/yfvabjvm_IMG_4384.heic",
    description: "Spacious grey stone patio with brick garage extension"
  },
  {
    id: 21,
    title: "Modern Exterior Renovation with Rendering",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/2ki520id_IMG_5980.heic",
    description: "Contemporary white render facade with new windows and entrance"
  },
  {
    id: 22,
    title: "Full House Renovation Project",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/853i8f62_IMG_5307.heic",
    description: "Complete renovation with scaffolding and MS Building Contractors on-site"
  },
  {
    id: 23,
    title: "Exterior Renovation with Scaffolding",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/i4j6i8oi_IMG_5301.heic",
    description: "House exterior renovation with window replacement and facade work"
  },
  {
    id: 24,
    title: "Interior Wall Framing Installation",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/3yo3utij_IMG_5131.heic",
    description: "Professional interior framing with electrical and plumbing rough-in"
  },
  {
    id: 25,
    title: "Interior Space Reconfiguration",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/4kow88ed_IMG_5132.heic",
    description: "New interior partitions with timber stud framing and plasterboard"
  },
  {
    id: 26,
    title: "Block Wall Construction for Patio",
    category: "Patio",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/4z2aw2tn_IMG_3807.heic",
    description: "Foundation and block wall construction on concrete base"
  },
  {
    id: 27,
    title: "Extension Wall Building with Insulation",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/exxefjsc_IMG_3809.heic",
    description: "Concrete block walls with reflective insulation for extension"
  },
  {
    id: 28,
    title: "Ground Floor Extension Construction",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/g5vgwk84_IMG_3844.heic",
    description: "New room extension with concrete block masonry work in progress"
  },
  {
    id: 29,
    title: "Patio Foundation Preparation",
    category: "Patio",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/petugj7j_IMG_3774.heic",
    description: "Sand base compaction with brick border for paved patio area"
  },
  {
    id: 30,
    title: "Skylight Installation on Flat Roof",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/oga6w70t_IMG_3758.heic",
    description: "Double pyramid skylights installed on waterproofed flat roof"
  },
  {
    id: 31,
    title: "Modern Single-Storey Extension with Flat Roof",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/mpuavxxj_IMG_3146.png",
    description: "Stunning brick extension with large glazed doors and windows"
  },
  {
    id: 32,
    title: "Contemporary House Extension",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/7lx4n3yn_IMG_4965.heic",
    description: "Modern extension with quality brickwork and glazing"
  },
  {
    id: 33,
    title: "Complete Extension Build",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/g59hg08w_IMG_4963.heic",
    description: "Professional extension construction with matching brickwork"
  },
  {
    id: 34,
    title: "House Extension Project",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/8bckscas_IMG_4570.heic",
    description: "Quality residential extension with contemporary design"
  },
  {
    id: 35,
    title: "Residential Extension Addition",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/mpmirkpm_IMG_3378.heic",
    description: "Expert extension work with professional finish"
  },
  {
    id: 36,
    title: "Brick Extension with French Doors and Stone Patio",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/mxrrwqwj_IMG_2944.jpeg",
    description: "Beautiful brick extension with white French doors and premium stone patio"
  },
  {
    id: 37,
    title: "Quality Extension Build",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/censshgu_IMG_3095.heic",
    description: "Professional extension construction with quality finishes"
  },
  {
    id: 38,
    title: "Modern House Extension",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/kpg660kh_IMG_3074.heic",
    description: "Contemporary extension with expert craftsmanship"
  },
  {
    id: 39,
    title: "Complete Extension Project",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/qjrh54d7_IMG_2980.heic",
    description: "Full extension build with professional results"
  },
  {
    id: 40,
    title: "Residential Extension Work",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/e6e1z5ad_IMG_2891.heic",
    description: "High-quality residential extension installation"
  },
  {
    id: 41,
    title: "Contemporary Timber Garden Room",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/gp2zo3e4_eeacb536-700f-4095-9f38-85ac9c0b8edc.jpeg",
    description: "Stunning timber-clad extension with large bi-fold glazed doors"
  },
  {
    id: 42,
    title: "Two-Storey Extension with Black Stone Patio",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/ro3xewwp_bbf4c3c0-9c12-45b0-974f-fa9f0aed1099.jpeg",
    description: "Double-storey brick extension with French doors and premium patio"
  },
  {
    id: 43,
    title: "Two-Storey Extension with Solar Panels",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/u80nbij1_1efbedd3-efb5-4613-8d2f-51d1152ec34e.jpeg",
    description: "Modern two-storey extension with solar panel installation"
  },
  {
    id: 44,
    title: "Block Extension Under Construction",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/1978m752_e863c78c-4809-44cd-9d54-836942e0974b.jpeg",
    description: "Extension construction showing quality blockwork and red tile roof"
  },
  {
    id: 45,
    title: "Extension Construction Project",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/21s6k78a_IMG_0614.heic",
    description: "Professional extension build in progress"
  },
  {
    id: 46,
    title: "Loft Conversion with Grey Cladding",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/u2ma2qt0_56025349-b36b-4dc6-adab-e575240fdfdf.jpeg",
    description: "Modern dormer loft conversion with contemporary grey cladding and blockwork"
  },
  {
    id: 47,
    title: "Loft Extension Timber Frame Construction",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/odvglv67_3fed5896-f28a-43d4-916f-7f65af005141.jpeg",
    description: "Professional timber frame loft extension construction with scaffolding"
  },
  {
    id: 48,
    title: "Two-Storey Extension with French Doors",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/t9rg4jn4_5aed9ebf-9eaa-4180-8917-e3f93d51c5c9.jpeg",
    description: "Completed double-storey brick extension with white French doors"
  },
  {
    id: 49,
    title: "Multi-Storey Extension Construction",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/3bmeml95_IMG_2124.jpeg",
    description: "Large-scale residential extension with dormer windows and roof work"
  },
  {
    id: 50,
    title: "Stunning White Rendered Property",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/5z54p55v_IMG_2734.png",
    description: "Beautiful white render with black windows, doors and traditional clay tile roof"
  },
  {
    id: 51,
    title: "Professional Construction Project",
    category: "Extension",
    image: "https://customer-assets.emergentagent.com/job_ms-contractors-work/artifacts/j1fj74ni_IMG_2827.heic",
    description: "Quality building work by MS Building Contractors"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    project: "Kitchen & Extension",
    rating: 5,
    comment: "MS Building Contractors transformed our home with a beautiful extension and kitchen. The full package service took all the stress away - highly recommended!",
    date: "January 2026"
  },
  {
    id: 2,
    name: "David Mitchell",
    project: "Double Storey Extension",
    rating: 5,
    comment: "Professional team, excellent workmanship, and completed on time. The hassle-free package meant we didn't have to coordinate multiple trades.",
    date: "December 2025"
  },
  {
    id: 3,
    name: "Emma Roberts",
    project: "Kitchen Renovation",
    rating: 5,
    comment: "Fantastic job on our kitchen renovation. Martyn and Jake were brilliant throughout the project. Would definitely use again.",
    date: "November 2025"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "All Jobs Welcome",
    description: "No job too big or too small - from maintenance and repairs to full extension packages, we handle all aspects of building work."
  },
  {
    id: 2,
    title: "Experienced Team",
    description: "With years of experience in all building trades, we deliver quality craftsmanship on every project, regardless of size."
  },
  {
    id: 3,
    title: "Full Project Management",
    description: "From initial consultation to final completion, we coordinate all trades and manage every aspect of your project professionally."
  },
  {
    id: 4,
    title: "Quality Guaranteed",
    description: "Whether it's a small repair or complete renovation, we take pride in our work and ensure the highest standards every time."
  }
];

// Mock form submission
export const submitBookingForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Booking form submitted:", formData);
      resolve({ success: true, message: "Thank you! We'll contact you within 24 hours." });
    }, 1000);
  });
};
